import {
  APPROVED,
  DEFERRED,
  RECOMMENDED_FOR_APPROVAL,
  REJECTED,
} from "../../utils/constants";
import { createSelectItem } from "../../utils/helpers";
import { customActionFields } from "../handlers/useActionHandler";
import { sourceApis } from "../handlers/useApiHandler";

// SET GENERIC ACTION FORM
export function useGenericActionForm({ form, source }) {
  const actionsList = customActionFields[source] || [
    RECOMMENDED_FOR_APPROVAL,
    APPROVED,
    DEFERRED,
    REJECTED,
  ];

  // action select options
  const actions = [...actionsList.map((action) => createSelectItem(action))];

  // consturct action form fields
  const fields = [
    {
      field_name: "status",
      type: "select",
      props: { required: true },
      options_data: actions,
    },
    {
      field_name: "comment",
      label: "Comment",
      type: "textarea",
      props: {
        required: form?.status === REJECTED,
        wide: true,
      },
    },
  ];

  // for submitting actions
  function onSubmit(payload: any, id: any) {
    if (id) {
      const api = sourceApis[source];
      if (!api) return;
      return {
        id,
        api,
        params: { ...payload, action_comment: payload?.comment || "" },
      };
    }
  }

  const enableSubmit = Object.keys(form).length > 0;

  return { fields, onSubmit, enableSubmit };
}
